module.exports = __webpack_public_path__ + "static/media/Mandurah-web.a22117f0.jpg";